<template>
    <div
    class="modal right fade trader-info c-offer-modal"
    id="trader-info"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"       
    >
    <div class="modal-dialog modal-dialog-centered modal-xl " role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title">Filters</h5>
            <button type="button" class="close"  @click="$emit('close')">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form>
                <div class="form-row justify-content-start">
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Name</label>
                        <input  type="text" class="form-control" id="inputEmail4" placeholder="Name"  v-model="filterData.name" >
                    </div>
                    <div class="form-group col-md-6">
                        <label for="inputLast">Description</label>
                        <input type="text" class="form-control" id="inputLast" placeholder="description"  v-model="filterData.description" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Product</label>
                        <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="filterData.offeringTypeId">
                            <option value="1">MUNICIPAL</option>
                            <option value="2">CORPORATE</option>                  
                        </select>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Coupon %</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="minCoupon"  v-model="filterData.minCoupon" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Coupon %</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Coupon"  v-model="filterData.maxCoupon" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Qty</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Quantity"  v-model="filterData.minQuantity" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Qty</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Quantity"  v-model="filterData.maxQuantity" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Purchase Date</label>
                        <datepicker v-model="filterData.minDate" placeholder="mm/dd/yyyy" typeable name="Min  Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Purchase Date</label>
                        <datepicker v-model="filterData.maxDate" placeholder="mm/dd/yyyy" typeable name="Max  Date" format="MM/dd/yyyy" :calendar-button="true" calendar-button-icon="fas fa-calendar-alt datepicker_icon"></datepicker> 
                    </div>
                   
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Gain/Loss Amount</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Gain/Loss Amount"  v-model="filterData.lossAmountMin" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Gain/Loss Amount</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Gain/Loss Amount"  v-model="filterData.lossAmountMax" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min Gain/Loss %</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Gain/Loss %"  v-model="filterData.lossPercentageMin" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Gain/Loss %</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Gain/Loss %"  v-model="filterData.lossPercentageMax" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Min IDC Price </label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Min IDC Price"  v-model="filterData.minPrice" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max IDC Price</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max IDC Price"  v-model="filterData.maxPrice" >
                    </div>
                    
                   
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">S&P Rating From </label>
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFrom">
                            <option value>Please select</option>
                            <option
                            v-for="spfrom in spRatingConstants"
                            :key="spfrom"
                            v-bind:value="spfrom"
                        >{{spfrom}}</option>
                        </select>
                    </div> 
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">S&P Rating To</label>
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingTo">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                          </select>
                    </div>
                    <div class="form-group col-md-2">
                         <label for="inputEmail4">Underlying Rating From </label>
                          <select @change="checkRatingRangeisValidUnder()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFromUnder">
                              <option value>Please select</option>
                              <option
                              v-for="spfrom in spRatingConstants"
                              :key="spfrom"
                              v-bind:value="spfrom"
                            >{{spfrom}}</option>
                            </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="inputEmail4">Underlying Rating To</label>
                        <select @change="checkRatingRangeisValidUnder()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingToUnder">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                        </select>
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4"> Min Maturity Year</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder=" Min Maturity Year"  v-model="filterData.minMaturityYear" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Maturity Year</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Maturity Year"  v-model="filterData.maxMaturityYear" >
                    </div> 
                      <div class="form-group col-md-2">
                        <label for="inputEmail4"> Min Call Year</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder=" Min Call Year"  v-model="filterData.minCallYear" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Call Year</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Call Year"  v-model="filterData.maxCallYear" >
                    </div> 
                    <div class="form-group col-md-2">
                            <label for="inputEmail4">Cash Available</label>
                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="isCashAvlbCheck">
                                <option value="">Select</option>
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>                  
                            </select>
                    </div> 
                    <div class="form-group col-md-2" >
                            <label for="inputEmail4">Min Cash Available</label>
                            <input  type="number" :disabled="isCashAvlbCheck !== 'YES'" class="form-control" id="inputEmail4" placeholder="Min Cash Available"  v-model="filterData.minCashAvailable" >
                        </div>
                        <div class="form-group col-md-2" >
                            <label for="inputEmail4">Max Cash Available</label>
                            <input  type="number" :disabled="isCashAvlbCheck !== 'YES'" class="form-control" id="inputEmail4" placeholder="Max Cash Available"  v-model="filterData.maxCashAvailable" >
                        </div> 
                    <div class="form-row col-md-6">
                        <!-- <div class="form-group col-md-4">
                            <label for="inputEmail4">Cash Available</label>
                            <select class="form-control" id="exampleFormControlSelect1" placeholder="Please select"  v-model="isCashAvlbCheck">
                                <option value="">Select</option>
                                <option value="YES">YES</option>
                                <option value="NO">NO</option>                  
                            </select>
                        </div> -->
                        <!-- <div class="form-group col-md-4" v-if="isCashAvlbCheck == 'YES'">
                            <label for="inputEmail4">Min Cash Available</label>
                            <input  type="number" class="form-control" id="inputEmail4" placeholder="Min Cash Available"  v-model="filterData.minCashAvailable" >
                        </div>
                        <div class="form-group col-md-4" v-if="isCashAvlbCheck == 'YES'">
                            <label for="inputEmail4">Max Cash Available</label>
                            <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Cash Available"  v-model="filterData.maxCashAvailable" >
                        </div> -->
                        <!-- <div class="form-group col-md-4 ">
                            <label for="inputEmail4">RatingSP From </label>
                            <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFrom">
                                <option value>Please select</option>
                                <option
                                v-for="spfrom in spRatingConstants"
                                :key="spfrom"
                                v-bind:value="spfrom"
                            >{{spfrom}}</option>
                            </select>
                        </div> -->
                    </div>
                    <!-- <div class="form-group col-md-4 ">
                        <label for="inputEmail4">RatingSP To</label>
                        <select @change="checkRatingRangeisValid()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingTo">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                          </select>
                    </div>
                    <div class="form-group col-md-2">
                         <label for="inputEmail4">Underlying Rating From </label>
                          <select @change="checkRatingRangeisValidUnder()" class="form-control" id="exampleFormControlSelect"  v-model="ratingFromUnder">
                              <option value>Please select</option>
                              <option
                              v-for="spfrom in spRatingConstants"
                              :key="spfrom"
                              v-bind:value="spfrom"
                            >{{spfrom}}</option>
                            </select>
                    </div>
                    <div class="form-group col-md-2">
                      <label for="inputEmail4">Underlying Rating To</label>
                        <select @change="checkRatingRangeisValidUnder()" class="form-control" id="exampleFormControlSelect1"  v-model="ratingToUnder">
                            <option value>Please select</option>
                            <option
                            v-for="sp in spRatingConstants"
                            :key="sp"
                            v-bind:value="sp"
                            
                          >{{sp}}</option>
                        </select>
                    </div>
                     <div class="form-group col-md-2">
                        <label for="inputEmail4"> Min Maturity Year</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder=" Min Maturity Year"  v-model="filterData.minMaturityYear" >
                    </div>
                    <div class="form-group col-md-2">
                        <label for="inputEmail4">Max Maturity Year</label>
                        <input  type="number" class="form-control" id="inputEmail4" placeholder="Max Maturity Year"  v-model="filterData.maxMaturityYear" >
                    </div>   -->
                
                    
                </div>
                <div class="form-row">
                   <div :class="accountColClass">
                        <div class="d-flex justify-content-between">
                            <label for="inputEmail4">
                                Accounts
                            </label>
                            <div>
                                <a class="text-primary" style="color:#0084CC !important; font-size: 12px;cursor: pointer;font-weight: 600;" @click="showImportModal = true">
                                <i data-v-04c24514="" class="fas fa-cloud-upload-alt"  style="color:#0084CC !important; font-size: 12px;cursor: pointer;font-weight: 600;" ></i>
                                    Import Accounts</a>
                            </div>
                        </div>
                        <multiselect 
                            v-model="filterAccounts" 
                            placeholder="Select" 
                            :options="sortedAccountOptions"
                            label="accountName" 
                            track-by="accountMappingId"  
                            :multiple="true" 
                             ></multiselect>
                    </div>
                </div>
                <div class="form-row align-items-start">
                    <div class="form-group col-md-6">
                      <label for="inputLast">States</label> 
                      <div class="d-flex justify-content-between m-3">
                        <!-- <div>
                            <label class="mr-3">
                                <input type="radio" v-model="stateConstraint" value="EXCLUDE">
                                EXCLUDE
                            </label>
                            <label class="mr-3">
                                <input type="radio" v-model="stateConstraint" value="INCLUDE">
                                INCLUDE
                            </label>
                            <label>
                                <input type="radio" v-model="stateConstraint" value="ONLY_IF">
                                ONLY IF
                            </label>
                        </div> -->
                        <div>
                            <a class="allStates" @click="selectAllState()">
                                <i class="fa fa-angle-right"></i> {{isStateSelectAll ? 'Select' : 'Unselect'}} All</a>
                        </div>
                        
                      </div>
                      
                      <div class="flex-container">
                        <div v-for="state in stateCodes" :key="state.code" @click="selectState(state)" class="cursor-pointer states" :class="{ statesAtive: state.isActive }">
                          {{ state.short }}
                        </div>
                      </div>
                    </div>
                    <div class="form-group col-md-6 attributes">
                        <label for="inputEmail4">Attributes</label><a class="allStates" @click="clearAllAttributes()"><i class="fa fa-trash"></i> Clear All</a>
                        <table class="table align-items-center table-flush table-hover bidtbl">
                          <thead class="thead-light">
                            <tr>
                              <th scope="col" class="sort text-left"></th>
                              
                              <th scope="col" class="sort text-center">Exclude</th>
                              <th scope="col" class="sort text-center">Include</th>
                              <th scope="col" class="sort text-center">Only If</th>
                            </tr>
                          </thead>
                          <tbody class="list no-cursor attr-table">
                            <tr>
                              <td>PreRefund</td>

                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="excludePreRefund" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="includePreRefund" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.preRefund" name="includePreRefund" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>escrowed</td>
              
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="excludeescrowed" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="includeescrowed" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.escrowed" name="includeescrowed" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>insured</td>
                          
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="excludeinsured" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="includeinsured" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.insured" name="includeinsured" value="onlyif">
                                </div>
                              </td>
                            </tr>
                          
                            <tr>
                              <td>taxable</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="excludetaxable" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="includetaxable" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.taxable" name="includetaxable" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>AMT</td>
                             
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="excludeAMT" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="includeAMT" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.amt" name="includeAMT" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>bank Q</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="excludebankQ" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="includebankQ" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.bankQ" name="includebankQ" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>callable</td>
                     
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="excludecallable" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="includecallable" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.callable" name="includecallable" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>putable</td>
                         
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="excludeputable" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="includeputable" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.putable" name="includeputable" value="onlyif">
                                </div>
                              </td>
                            </tr>
                           
                            <tr> 
                              <td>sinking Fund</td>
                              
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="excludesinkingFund" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="includesinkingFund" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.sinkingFund" name="includesinkingFund" value="onlyif">
                                </div>
                              </td>
                            </tr>
                           
                            <tr>
                              <td>zero Coupon</td>
                            
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="excludezeroCoupon" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="includezeroCoupon" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.zeroCoupon" name="includezeroCoupon" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>below Min</td>
                             
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="excludebelowMin" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="includebelowMin" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.belowMin" name="includebelowMin" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            
                            <tr>
                              <td>green Bonds</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.greenBonds" name="excludegreenBonds" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.greenBonds" name="includegreenBonds" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.greenBonds" name="includegreenBonds" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>technical Default</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="excludetechnicalDefault" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="includetechnicalDefault" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.technicalDefault" name="includetechnicalDefault" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td>Irregular Settlement</td>
                           
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="exclude">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="include">
                                </div>
                              </td>
                              <td class="text-center">
                                <div class="form-check">
                                  <input class="form-check-input" type="radio" v-model="filterData.irregularSettlement" name="irregularSettlement" value="onlyif">
                                </div>
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                    </div>
                    <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                </div>
                <div class="modal-footer bid" v-if="!isDuplicate">
                    <button type="button" class="btn btn-secondary"  @click="clear()">RESET</button>
                    <button v-if="!editFilterId"  type="button" class="btn btn-primary" @click="applyFilter()">APPLY</button>
                    <button v-if="!editFilterId"  type="button" class="btn btn-info" @click="saveAndApplyFilter()">SAVE</button>
                    <button v-if="editFilterId"  type="button" class="btn btn-info" @click="updateFilter()">UPDATE</button>
                </div>
                <div class="modal-footer bid" v-if="isDuplicate">
                    <button type="button" class="btn btn-secondary" @click="saveAndApplyFilter()" >DUPLICATE</button>
                </div>
            </form>

       
        </div>
        </div>
    </div>
    <AccountsImportModal 
        v-on:applyFilter="applyAccounts" 
     v-if="showImportModal" 
     @close="showImportModal = false"/>
    </div>
</template>

<script>
    import authService from "@/authService";
    import config from "@/config";
    import Datepicker from 'vuejs-datepicker';
    import stateConstants from "@/stateConstants";
    import AccountsImportModal from "./BaImportCusips.vue";
    import spRatingConstants from "@/spRatingConstants";

    export default {
        name: 'inventoryAddmodal',
        components :{
            Datepicker,
            AccountsImportModal
        },
        props: ['activeFilter','editFilterId','loadFilterId','isDuplicate'],
        computed: {
            sortedAccountOptions() {
                if (!this.filterAccounts || this.filterAccounts.length === 0) {
                    return this.accountList
                }

                const selectedIds = this.filterAccounts.map(c => c.accountMappingId)
                return [
                ...this.accountList.filter(c => selectedIds.includes(c.accountMappingId)),
                ...this.accountList.filter(c => !selectedIds.includes(c.accountMappingId))
                ]
            },
             accountColClass() {
                return this.filterAccounts.length > 3
                  ? 'form-group col-md-12'
                  : 'form-group col-md-6'
              }
            },
        data() {
            return {
                loading : false,
                filterData : {
                    offeringTypeId : '1'
                },
                accountList : [],
                filterAccounts : [],
                stateConstantsCopy: stateConstants,
                stateCodes : [],
                selelctedStates: [],
                isStateSelectAll : true,
                stateConstraint : 'EXCLUDE',
                isCashAvlbCheck : "",
                showImportModal : false,
                spRatingConstants:spRatingConstants,
                ratingFrom:"",
                ratingTo:"",
                ratingFromUnder:"",
                ratingToUnder:"",


            };
        },
        methods: {
            clearAllAttributes() {
                const filters = [
                    'preRefund',
                    'escrowed',
                    'insured',
                    'taxable',
                    'amt',
                    'bankQ',
                    'callable',
                    'putable',
                    'sinkingFund',
                    'zeroCoupon',
                    'belowMin',
                    'greenBonds',
                    'technicalDefault',
                    'irregularSettlement'

                ];
                for (const filter of filters) {
                    this.filterData[filter] = null;
                }
                },
             checkRatingRangeisValidUnder(){
                var stringArry = [...this.spRatingConstants].reverse();
                if(this.ratingFromUnder && this.ratingToUnder){
                    var startIndex = stringArry.indexOf(this.ratingFromUnder);
                    var endIndex = stringArry.indexOf(this.ratingToUnder);
                    if(startIndex <= endIndex) {
                        console.log('Selected range is valid');
                    } else {
                        this.$alert('From Rating should be lower than to rating',"","error");
                        this.ratingFromUnder = "";
                        this.ratingToUnder = "";
                    }
                }

                },
            getRangeOfRatings(datafrom,datato){
                console.log(datafrom,datato)
                var stringArry = [...this.spRatingConstants].reverse();
                var startIndex = stringArry.indexOf(datafrom);
                var endIndex = stringArry.indexOf(datato);
                var range = [];
                if(startIndex > endIndex){
                    // swap the values
                    var temp = startIndex;
                    startIndex = endIndex;
                    endIndex = temp;
                }
                if(datafrom && datato){
                    range = stringArry.slice(startIndex, endIndex + 1);
                }else{
                    range = []
                }
                return range;
            },
            checkRatingRangeisValid(){
                var stringArry = [...this.spRatingConstants].reverse();
                if(this.ratingFrom && this.ratingTo){
                    var startIndex = stringArry.indexOf(this.ratingFrom);
                    var endIndex = stringArry.indexOf(this.ratingTo);
                    if(startIndex <= endIndex) {
                        console.log('Selected range is valid');
                    } else {
                        this.$alert('From Rating should be lower than to rating',"","error");
                        this.ratingFrom = "";
                        this.ratingTo = "";
                    }
                }

            },
            applyAccounts(data){
                this.filterAccounts = [];
                let selectedAccounts = this.accountList.filter(account => data.accountMappings.includes(account.accountMappingId));
                this.filterAccounts = selectedAccounts;
                this.showImportModal = false;
            //   this.getAllAccountList();
            },
            clear(){
                this.filterData = {};
                this.filterData.offeringTypeId = '1';
                this.stateConstraint = 'EXCLUDE'
                this.stateCodes.map(state => state.isActive = false)
                this.filterAccounts = [];
                this.isCashAvlbCheck = "";
                this.ratingFrom = "";
                this.ratingTo = "";
                this.ratingFromUnder = "";
                this.ratingToUnder = "";

            },
            getAllAccountList(){
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlBidSide +
                    "/inventory/account-map-list",
                    auth
                )
                .then(result => {
                    this.accountList = result.data.map(item => {
                        return {
                            accountMappingId: item.accountMappingId,
                            account: item.account,
                            accountName: item.account + " - " + item.customerName
                        }
                    });
                    this.setFilter();
                })
            }, 
            selectAllState(){
                if(this.isStateSelectAll){
                    this.stateCodes.map(state => state.isActive = true)
                    this.isStateSelectAll = false
                }else{
                    this.stateCodes.map(state => state.isActive = false)
                    this.isStateSelectAll = true
                }
            },
            selectState(state){
                state.isActive = !state.isActive
            },
            applyFilter(){
              let applyData = {};
              applyData.accountMappings = this.filterAccounts.map((acc) => acc.accountMappingId);  
              applyData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short);
              applyData.description = this.filterData.description;
            //   applyData.stateConstraint = this.stateConstraint; 
              applyData.minCoupon = Number(this.filterData.minCoupon) || "";  
              applyData.maxCoupon = Number(this.filterData.maxCoupon) || "";  
              applyData.minQuantity = Number(this.filterData.minQuantity) || "";  
              applyData.maxQuantity = Number(this.filterData.maxQuantity) || "";  
              applyData.minDate =    this.filterData.minDate ? this.moment(this.filterData.minDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;    
              applyData.maxDate =    this.filterData.maxDate ? this.moment(this.filterData.maxDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;  
              applyData.lossAmountMax = Number(this.filterData.lossAmountMax) || "";  
              applyData.lossAmountMin = Number(this.filterData.lossAmountMin) || "";  
              applyData.lossPercentageMax = Number(this.filterData.lossPercentageMax) || "";  
              applyData.lossPercentageMin = Number(this.filterData.lossPercentageMin) || "";  
              applyData.minPrice = Number(this.filterData.minPrice) || "";  
              applyData.maxPrice = Number(this.filterData.maxPrice) || "";  

              applyData.minMaturityYear = Number(this.filterData.minMaturityYear) || "";  
              applyData.maxMaturityYear = Number(this.filterData.maxMaturityYear) || "";
              applyData.minCallYear = Number(this.filterData.minCallYear) || "";
              applyData.maxCallYear = Number(this.filterData.maxCallYear) || "";

              if(this.ratingFrom && !this.ratingTo){
                  this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
              }
              if(this.ratingTo && !this.ratingFrom){
                  this.ratingFrom = this.spRatingConstants[0];
              }

              if(this.ratingFromUnder && !this.ratingToUnder){
                  this.ratingToUnder = this.spRatingConstants[this.spRatingConstants.length - 1];
              }
              if(this.ratingToUnder && !this.ratingFromUnder){
                  this.ratingFromUnder = this.spRatingConstants[0];
              }

              applyData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo);
              applyData.ratingUnderlying = this.getRangeOfRatings(this.ratingFromUnder,this.ratingToUnder);
              applyData.offeringTypeId =  this.filterData.offeringTypeId || '1';


              
            //   applyData.isCashAvlbCheck = this.filterData.isCashAvlbCheck == 'YES' ?  'NO' || null;  

             
              applyData.minCashAvailable = Number(this.filterData.minCashAvailable) || "";  
              applyData.maxCashAvailable = Number(this.filterData.maxCashAvailable) || "";  
              if(this.isCashAvlbCheck == 'YES'){
                applyData.isCashAvlbCheck = true;
              }
              if(this.isCashAvlbCheck == 'NO'){
                applyData.isCashAvlbCheck = false;
                applyData.minCashAvailable = "";
                applyData.maxCashAvailable = "";
              }
              if(!this.isCashAvlbCheck){
                applyData.isCashAvlbCheck = null;
              }

              //attribute filters
              applyData.preRefund = this.filterData.preRefund || null;
              applyData.escrowed = this.filterData.escrowed || null;
              applyData.insured = this.filterData.insured || null;
              applyData.taxable = this.filterData.taxable || null;
              applyData.amt = this.filterData.amt || null;
              applyData.bankQ = this.filterData.bankQ || null;
              applyData.callable = this.filterData.callable || null;
              applyData.putable = this.filterData.putable || null;
              applyData.sinkingFund = this.filterData.sinkingFund || null;
              applyData.zeroCoupon = this.filterData.zeroCoupon || null;
              applyData.belowMin = this.filterData.belowMin || null;
              applyData.greenBonds = this.filterData.greenBonds || null;
              applyData.technicalDefault = this.filterData.technicalDefault || null;
              applyData.irregularSettlement = this.filterData.irregularSettlement || null;



              this.$emit('close');
              this.$emit('applyFilter',applyData);  
            },
            //updateFilter
            updateFilter() {
                if(!this.filterData.name){
                    this.$alert("Filter name is required", "", "error");
                    return false
                }
                this.loading = true;
                let applyData = {};
                    applyData.accountMappings = this.filterAccounts.map((acc) => acc.accountMappingId);  
                    applyData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short);
                    applyData.description = this.filterData.description;
                    // applyData.stateConstraint = this.stateConstraint; 
                    applyData.minCoupon = Number(this.filterData.minCoupon) || "";  
                    applyData.maxCoupon = Number(this.filterData.maxCoupon) || "";  
                    applyData.minQuantity = Number(this.filterData.minQuantity) || "";  
                    applyData.maxQuantity = Number(this.filterData.maxQuantity) || "";  
                    applyData.minDate =    this.filterData.minDate ? this.moment(this.filterData.minDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;    
                    applyData.maxDate =    this.filterData.maxDate ? this.moment(this.filterData.maxDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;  
                    applyData.lossAmountMax = Number(this.filterData.lossAmountMax) || "";  
                    applyData.lossAmountMin = Number(this.filterData.lossAmountMin) || "";  
                    applyData.lossPercentageMax = Number(this.filterData.lossPercentageMax) || "";  
                    applyData.lossPercentageMin = Number(this.filterData.lossPercentageMin) || "";  
                    applyData.minPrice = Number(this.filterData.minPrice) || "";  
                    applyData.maxPrice = Number(this.filterData.maxPrice) || "";  
                    // applyData.isCashAvlbCheck = this.filterData.isCashAvlbCheck || null; 
                    applyData.minCashAvailable = Number(this.filterData.minCashAvailable) || "";  
                    applyData.maxCashAvailable = Number(this.filterData.maxCashAvailable) || "";  
                    applyData.minMaturityYear = Number(this.filterData.minMaturityYear) || "";  
                    applyData.maxMaturityYear = Number(this.filterData.maxMaturityYear) || "";
                    applyData.minCallYear = Number(this.filterData.minCallYear) || "";
                    applyData.maxCallYear = Number(this.filterData.maxCallYear) || "";

                    if(this.ratingFrom && !this.ratingTo){
                        this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
                    }
                    if(this.ratingTo && !this.ratingFrom){
                        this.ratingFrom = this.spRatingConstants[0];
                    }

                    if(this.ratingFromUnder && !this.ratingToUnder){
                        this.ratingToUnder = this.spRatingConstants[this.spRatingConstants.length - 1];
                    }
                    if(this.ratingToUnder && !this.ratingFromUnder){
                       this.ratingFromUnder = this.spRatingConstants[0];
                    }

                    applyData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo);
                    applyData.ratingUnderlying = this.getRangeOfRatings(this.ratingFromUnder,this.ratingToUnder);

                     applyData.offeringTypeId =  this.filterData.offeringTypeId || '1';

                    console.log(this.isCashAvlbCheck)
                    if(this.isCashAvlbCheck == 'YES'){
                        applyData.isCashAvlbCheck = true;
                    }
                    else if (this.isCashAvlbCheck =='NO') {
                        applyData.isCashAvlbCheck = false;
                        applyData.minCashAvailable = "";
                        applyData.maxCashAvailable = "";
                    } else {
                        applyData.isCashAvlbCheck = null
                    }


                    applyData.status =  "ACTIVE";
                    applyData.userId = authService.getUser().id;
                    applyData.name = this.filterData.name;
                    applyData.id = this.filterData.id;


                     //attribute filters
                      applyData.preRefund = this.filterData.preRefund || null;
                      applyData.escrowed = this.filterData.escrowed || null;
                      applyData.insured = this.filterData.insured || null;
                      applyData.taxable = this.filterData.taxable || null;
                      applyData.amt = this.filterData.amt || null;
                      applyData.bankQ = this.filterData.bankQ || null;
                      applyData.callable = this.filterData.callable || null;
                      applyData.putable = this.filterData.putable || null;
                      applyData.sinkingFund = this.filterData.sinkingFund || null;
                      applyData.zeroCoupon = this.filterData.zeroCoupon || null;
                      applyData.belowMin = this.filterData.belowMin || null;
                      applyData.greenBonds = this.filterData.greenBonds || null;
                      applyData.technicalDefault = this.filterData.technicalDefault || null;
                      applyData.irregularSettlement = this.filterData.irregularSettlement || null;
    
                const auth = {
                    headers: { "org-token": authService.getOrgToken() },
                };
                this.$http
                .put(config.baseUrlAutoBidder + "/bidwanted/filter", applyData, auth)
                .then(() => {
                    this.loading = false;
                    this.$alert("Successfully updated", "", "success");
                    this.$emit("close");
                    // delete applyData.status;
                    // delete applyData.userId;
                    this.$emit('applySavedFilter',this.filterData.id);  

                })
                .catch(() => {
                    this.loading = false;
                });
                
            },
            saveAndApplyFilter() {
                if(!this.filterData.name){
                    this.$alert("Filter name is required", "", "error");
                    return false
                }
                this.loading = true;
                let applyData = {};
                    applyData.accountMappings = this.filterAccounts.map((acc) => acc.accountMappingId);  
                    applyData.states =  this.stateCodes.filter(user => user.isActive === true).map(state => state.short);
                    applyData.description = this.filterData.description;
                    // applyData.stateConstraint = this.stateConstraint; 
                    applyData.minCoupon = Number(this.filterData.minCoupon) || "";  
                    applyData.maxCoupon = Number(this.filterData.maxCoupon) || "";  
                    applyData.minQuantity = Number(this.filterData.minQuantity) || "";  
                    applyData.maxQuantity = Number(this.filterData.maxQuantity) || "";  
                    applyData.minDate =    this.filterData.minDate ? this.moment(this.filterData.minDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;    
                    applyData.maxDate =    this.filterData.maxDate ? this.moment(this.filterData.maxDate).startOf('day').format("YYYY-MM-DD HH:mm:ss") : null;  
                    applyData.lossAmountMax = Number(this.filterData.lossAmountMax) || "";  
                    applyData.lossAmountMin = Number(this.filterData.lossAmountMin) || "";  
                    applyData.lossPercentageMax = Number(this.filterData.lossPercentageMax) || "";  
                    applyData.lossPercentageMin = Number(this.filterData.lossPercentageMin) || "";  
                    applyData.minPrice = Number(this.filterData.minPrice) || "";  
                    applyData.maxPrice = Number(this.filterData.maxPrice) || "";  
                    // applyData.isCashAvlbCheck = this.filterData.isCashAvlbCheck || null;                    
                    applyData.minCashAvailable = Number(this.filterData.minCashAvailable) || "";  
                    applyData.maxCashAvailable = Number(this.filterData.maxCashAvailable) || "";  
                    applyData.minMaturityYear = Number(this.filterData.minMaturityYear) || "";  
                    applyData.maxMaturityYear = Number(this.filterData.maxMaturityYear) || "";
                    applyData.minCallYear = Number(this.filterData.minCallYear) || "";  
                    applyData.maxCallYear = Number(this.filterData.maxCallYear) || "";

                    if(this.ratingFrom && !this.ratingTo){
                        this.ratingTo = this.spRatingConstants[this.spRatingConstants.length - 1];
                    }
                    if(this.ratingTo && !this.ratingFrom){
                        this.ratingFrom = this.spRatingConstants[0];
                    }
                    if(this.ratingFromUnder && !this.ratingToUnder){
                        this.ratingToUnder = this.spRatingConstants[this.spRatingConstants.length - 1];
                    }
                    if(this.ratingToUnder && !this.ratingFromUnder){
                       this.ratingFromUnder = this.spRatingConstants[0];
                    }
                    applyData.ratingSP = this.getRangeOfRatings(this.ratingFrom,this.ratingTo);
                    applyData.ratingUnderlying = this.getRangeOfRatings(this.ratingFromUnder,this.ratingToUnder);
            

                    if(this.isCashAvlbCheck == 'YES'){
                        applyData.isCashAvlbCheck = true;
                    }
                    else if (this.isCashAvlbCheck =='NO') {
                        applyData.isCashAvlbCheck = false;
                        applyData.minCashAvailable = "";
                        applyData.maxCashAvailable = "";
                    } else {
                        applyData.isCashAvlbCheck = null
                    }
                    applyData.status =  "ACTIVE";
                    applyData.userId = authService.getUser().id;
                    applyData.name = this.filterData.name
                    applyData.offeringTypeId =  this.filterData.offeringTypeId || '1';

                    
                     //attribute filters
                      applyData.preRefund = this.filterData.preRefund || null;
                      applyData.escrowed = this.filterData.escrowed || null;
                      applyData.insured = this.filterData.insured || null;
                      applyData.taxable = this.filterData.taxable || null;
                      applyData.amt = this.filterData.amt || null;
                      applyData.bankQ = this.filterData.bankQ || null;
                      applyData.callable = this.filterData.callable || null;
                      applyData.putable = this.filterData.putable || null;
                      applyData.sinkingFund = this.filterData.sinkingFund || null;
                      applyData.zeroCoupon = this.filterData.zeroCoupon || null;
                      applyData.belowMin = this.filterData.belowMin || null;
                      applyData.greenBonds = this.filterData.greenBonds || null;
                      applyData.technicalDefault = this.filterData.technicalDefault || null;
                      applyData.irregularSettlement = this.filterData.irregularSettlement || null;
    
                const auth = {
                    headers: { "org-token": authService.getOrgToken() },
                };
                this.$http
                .post(config.baseUrlAutoBidder + "/bidwanted/filter", applyData, auth)
                .then(() => {
                    this.loading = false;
                    this.$alert("Successfully added", "", "success");
                    this.$emit("close");
                    // this.$emit('applySavedFilter',this.filterData.id);  


                })
                .catch(() => {
                    this.loading = false;
                });
                
            },
            getFilterByFilterId(id){
                this.loading = true;
                const auth = {
                    headers: { 'org-token' : authService.getOrgToken() }
                };
                this.$http
                .get(
                config.baseUrlAutoBidder +
                    "/bidwanted/filter?id="+id,
                    auth
                )
                .then(result => {
                    this.activeFilter = result.data;
                    this.setFilter();
                    this.loading = false;

                })
            },
            setFilter(){
                if(this.activeFilter){
                    this.filterData = this.activeFilter;
                    // this.stateConstraint = this.filterData.stateConstraint || "EXCLUDE";
                    if(this.filterData.accountMappings.length){
                        this.filterAccounts = this.accountList.filter(item => this.filterData.accountMappings.includes(item.accountMappingId));
                    }
                    if(this.filterData.states){
                        this.filterData.states.map(code =>{
                            this.stateCodes.map(stateObj => {
                                if(stateObj.short == code) stateObj.isActive = true
                            })
                        });
                    }
                    if(this.filterData.isCashAvlbCheck){
                        this.isCashAvlbCheck = 'YES';
                    }
                    else if (this.filterData.isCashAvlbCheck === false) {
                        this.isCashAvlbCheck = 'NO';
                    } else {
                        this.isCashAvlbCheck = ''; // Set to empty string if null or undefined
                    }

                    if(this.isDuplicate){
                        this.filterData.name = this.activeFilter.name + " - Duplicate";
                        delete this.filterData.id;
                    }
                    // Prefill from saved filter for apply (not edit) — drop id so APPLY/SAVE show
                    if(this.loadFilterId && !this.editFilterId){
                        delete this.filterData.id;
                    }
                    if(this.filterData.ratingSP && this.filterData.ratingSP.length){
                        this.ratingFrom = this.filterData.ratingSP[0];
                        this.ratingTo = this.filterData.ratingSP[this.filterData.ratingSP.length - 1];
                    }
                    if(this.filterData.ratingUnderlying && this.filterData.ratingUnderlying.length){
                        this.ratingFromUnder = this.filterData.ratingUnderlying[0];
                        this.ratingToUnder = this.filterData.ratingUnderlying[this.filterData.ratingUnderlying.length - 1];
                    }    



                    

                }
                  

            }
       
        },
        mounted(){
            this.stateCodes = this.stateConstantsCopy.map(state => ({
                        short: state.short,
                        isActive: false
                      }));
            this.getAllAccountList();

           if(this.editFilterId){
            this.getFilterByFilterId(this.editFilterId)
           } else if(this.loadFilterId){
            this.getFilterByFilterId(this.loadFilterId)
           }

           
        }
    };
    </script>
    <style scoped>
    .modal i {
        margin-right: 2px;
    }
     .shake {
          animation: shake 0.82s cubic-bezier(0.36, 0.07, 0.19, 0.97) both;
          transform: translate3d(0, 0, 0);
        }
    
        @keyframes shake {
          10%,
          90% {
            transform: translate3d(-1px, 0, 0);
          }
    
          20%,
          80% {
            transform: translate3d(2px, 0, 0);
          }
    
          30%,
          50%,
          70% {
            transform: translate3d(-4px, 0, 0);
          }
    
          40%,
          60% {
            transform: translate3d(4px, 0, 0);
          }
        }
       .flex-container{
        display: flex;
        flex-wrap: wrap;
       }
       .flex-container div {
        padding: 5px;
       }
       .flex-container div.active{
        background-color: #006fae;
        color: white;
       }
       .attr-table td{
        text-transform: uppercase;
        padding: 3px;
       }
      
    </style>
